// extracted by mini-css-extract-plugin
export default {"lazyLoader":"gv-z"};